import React, { Suspense, useState, useEffect } from "react";
import { useSelector } from "react-redux";
import loadable from "@loadable/component";
import { Helmet } from "react-helmet-async";
import { getPageTitle } from "helpers";
import useAuth from "features/authentication/hooks/useAuth";
import { getAllApplicationIsLoaded } from "features/ApplicationLoader/applicationLoaderSelector";
import Loading from "@kateinnovations/ui-library/Loading";

import defaultPageData from "constants/defaultPageData";

import styles from "./resources/styles/template.module.scss";

const Routes = loadable(() => import(/* webpackChunkName: "Routes" */ "Routes"), {
    fallback: <Loading />,
});

const ApplicationLoader = loadable(() =>
    import(/* webpackChunkName: "applicationLoader" */ "features/ApplicationLoader")
);

const Template = () => {
    const auth = useAuth();
    const applicationIsLoaded = useSelector(getAllApplicationIsLoaded);
    const [showInitLoader, setShowInitLoader] = useState(true);
    const title = getPageTitle();
    const { description } = defaultPageData;

    useEffect(() => {
        const hideInitLoader = () => {
            setTimeout(() => {
                setShowInitLoader(false);
            }, 250);
        };

        if (applicationIsLoaded && auth) hideInitLoader();

        return () => clearTimeout(hideInitLoader);
    }, [applicationIsLoaded, auth]);

    useEffect(() => {
        if (!auth) setShowInitLoader(true);
    }, [auth]);

    if (showInitLoader && auth) return <ApplicationLoader />;

    return (
        <>
            <Helmet>
                <title>{title}</title>
                <meta name="description" content={description} />
            </Helmet>

            <div className={styles.main} variant="container">
                <Suspense fallback={<Loading />}>
                    <Routes />
                </Suspense>
            </div>
        </>
    );
};

export default Template;
